import { faPlus, faSearch, faSlidersH, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, Col, Container, Form, Offcanvas, Row, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { GET, POST } from '../../api';
import { colorPalette } from '../../constants/colorsPalette';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { handleFormErrors, readFile } from '../../helpers/form_helpers';
import { getExtension } from '../../helpers/general_helpers';
import { t } from '../../helpers/translation_helper';
import AddEditAssessmentReport from '../_common/AddEditAssessmentReport/_AddEditAssessmentReport';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import AssRepCard from './AssessRepCard';
import AIGenerationModal from '../_common/AI/AIGenerationModal';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';

class StudentAssessment extends Component {

  reportTypes = [
    {
      label: 'Detailed Observation',
      value: 'Detailed Observation',
    },
    {
      label: 'Summary Observation',
      value: 'Summary Observation',
    },
    {
      label: 'Learning Journal',
      value: 'Learning Journal',
    },
    {
      label: 'EY Report 1',
      value: 'EY Report 1',
    },
    {
      label: 'EY Report 2',
      value: 'EY Report 2',
    },
    {
      label: 'EY Report 3',
      value: 'EY Report 3',
    },
    {
      label: 'Progress Report',
      value: 'Progress Report',
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      working: false,
      getAssrepHeaderData: [],
      selectedAssrepHeader: null,
      selectedClass: null,
      selectedReportType: null,
      reportType: null,
      reportData: {
        processing: false,
        data: {},
      },
      assess_curr: [],
      isSaving: false,
      reRenderTime: moment(),
      studentListAssessment: null,
      terms: [],
      selectedTerm: null,
      dragAreaColor: {
        as_image: brand_colors[this.props.defaultTheme.theme_id].color18,
        toggleColor: (field, value) => this.setState({ dragAreaColor: { ...this.state.dragAreaColor, [field]: value } })
      },
      modalAssessSettings: {
        toggle: () => this.setState({ modalAssessSettings: { ...this.state.modalAssessSettings, show: !this.state.modalAssessSettings.show } }),
        show: false,
      },
      assessSettingsData: null,
      assess_setting_background_image: null,
      progassData: [],
      learnareaData: [],
    }
    this.assess_curr = [];

    this.AddEditAssessmentReport = React.createRef();
    this.assess_setting_background_image_ref = React.createRef();
  }

  componentDidMount() {
    this.getAssrepHeader();
    this.getTerms();
    this.getAssessSettings()
    this.getProgass()
    this.getLearnarea()
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authData.centerData.center_id !== this.props.authData.centerData.center_id) {
      this.assess_curr = [];
      this.setState({
        working: false,
        getAssrepHeaderData: [],
        selectedAssrepHeader: null,
        selectedClass: null,
        selectedReportType: null,
        reportType: null,
        reportData: {
          processing: false,
          data: {},
        },
        assess_curr: [],
        isSaving: false,
        reRenderTime: moment(),
        studentListAssessment: null,
        terms: [],
        selectedTerm: null,
        assessSettingsData: null,
        assess_setting_background_image: null,
        dragAreaColor: {
          assess_setting_background_image: brand_colors[this.props.defaultTheme.theme_id].color18,
          toggleColor: (field, value) => this.setState({ dragAreaColor: { ...this.state.dragAreaColor, [field]: value } })
        },
        modalAssessSettings: {
          toggle: () => this.setState({ modalAssessSettings: { ...this.state.modalAssessSettings, show: !this.state.modalAssessSettings.show } }),
          show: false,
        },
        progassData: [],
        learnareaData: [],
      }, () => {
        this.getAssrepHeader();
        this.getAssessSettings()
        this.getTerms();
        this.getProgass()
        this.getLearnarea()
      });
    }
  }

  getProgass = async () => {
    if (this.getProgassReq) {
      this.getProgassReq.abort();
    }
    this.getProgassReq = new AbortController();
    const res = await GET('student-tracker/get-progass', {
      signal: this.getProgassReq.signal,
      params: {
        active: 1,
      }
    });
    if (res) {
      this.setState({
        progassData: res.data.map((v, i) => {
          return { label: v.progass_code, value: v.progass_id, ...v }
        })
      })
    }
  };
  getLearnarea = async () => {
    if (this.getLearnareaReq) {
      this.getLearnareaReq.abort();
    }
    this.getLearnareaReq = new AbortController();
    const res = await GET('student-tracker/get-learnarea', {
      signal: this.getLearnareaReq.signal,
      params: {
        active: 1,
      }
    });
    if (res) {
      this.setState({
        learnareaData: res.data.map((v, i) => {
          return { label: v.learnarea_code, value: v.learnarea_id, ...v }
        })
      })
    }
  };

  handleDragFileArea = (e, name) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragover") {
      this.state.dragAreaColor.toggleColor(name, brand_colors[this.props.defaultTheme.theme_id].color1)
    } else if (e.type === "dragleave") {
      this.state.dragAreaColor.toggleColor(name, brand_colors[this.props.defaultTheme.theme_id].color18)
    }
  }
  addAttachment = (e) => {
    const selectedFiles = e.target.files;
    let allFiles = [];
    for (let i = 0; i < selectedFiles.length; i++) {
      allFiles.push(readFile(selectedFiles[i]));
    }
    Promise.all(allFiles).then((values) => {
      let attachments = e.target.multiple ? this.state[e.target.name] : null;
      let selectedFiles = values;
      selectedFiles.map((v, i) => {
        if (v.data.type) {
          if (e.target.multiple) {
            attachments.push({ url: v.url, data: v.data });
          } else {
            attachments = { url: v.url, data: v.data };
          }
        }
      });
      this.setState({ [e.target.name]: attachments, dragAreaColor: { ...this.state.dragAreaColor, [e.target.name]: brand_colors[this.props.defaultTheme.theme_id].color18 } });
    });
  };

  saveAssessSetting = async () => {

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    if (this.saveAssessSettingReq) {
      this.saveAssessSettingReq.abort()
    }
    this.saveAssessSettingReq = new AbortController();
    const { assessSettingsData, assess_setting_background_image, modalAssessSettings } = this.state;
    const fData = new FormData();
    fData.append('AssessSettings', JSON.stringify(assessSettingsData));
    if (assess_setting_background_image && assess_setting_background_image.data.name) {
      fData.append('assess_setting_background_image', assess_setting_background_image.data);
    }
    try {
      const res = await POST('assessment-report/update-assess-setting', fData, {
        signal: this.saveAssessSettingReq.signal
      });
      if (res) {
        let resData = res.data
        if (resData.type) {
          let assessSettingsData = resData.data
          this.setState({
            modalAssessSettings: { ...modalAssessSettings, show: false },
            assessSettingsData: assessSettingsData,
            assess_setting_background_image: (assessSettingsData.assess_setting_background_image) ? { url: regionalStorageURL + this.props.authData.centerData.center_uuid + '/assess_settings/' + assessSettingsData.assess_setting_background_image, data: { type: getExtension(assessSettingsData.assess_setting_background_image) } } : null
          })
          toast.success(t(resData.message));
        } else {
          if (resData.data) {
            handleFormErrors(resData.data)
          } else {
            toast.success(t(resData.message));
          }
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong!'));
    }
  }

  getAssessSettings = () => {

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    if (this.getAssessSettingsReq) {
      this.getAssessSettingsReq.abort();
    }
    this.getAssessSettingsReq = new AbortController();
    GET('assessment-report/get-assess-settings', {
      signal: this.getAssessSettingsReq.signal,
    }).then((res) => {
      if (res) {
        let assessSettingsData = null
        if (res.data) {
          assessSettingsData = {
            ...res.data,
            assess_setting_color1_open: false,
            assess_setting_color2_open: false,
            assess_setting_color3_open: false,
            assess_setting_color4_open: false,
          }
        } else {
          assessSettingsData = {
            assess_setting_color1: null,
            assess_setting_color1_open: false,
            assess_setting_color1_font: null,
            assess_setting_color2: null,
            assess_setting_color2_open: false,
            assess_setting_color2_font: null,
            assess_setting_color3: null,
            assess_setting_color3_open: false,
            assess_setting_color3_font: null,
            assess_setting_color4: null,
            assess_setting_color4_open: false,
            assess_setting_color4_font: null,
            assess_setting_color5: null,
            assess_setting_background_image: null,
            assess_title: null,
            assess_comment_title: null
          }
        }

        this.setState({
          assessSettingsData: assessSettingsData,
          assess_setting_background_image: (assessSettingsData.assess_setting_background_image) ? { url: regionalStorageURL + this.props.authData.centerData.center_uuid + '/assess_settings/' + assessSettingsData.assess_setting_background_image, data: { type: getExtension(assessSettingsData.assess_setting_background_image) } } : null
        })
      }
    })
  }

  getAssrepHeader = () => {
    try {
      if (this.getAssrepHeaderReq) {
        this.getAssrepHeaderReq.abort();
      }
      this.getAssrepHeaderReq = new AbortController();
      GET('assessment-report/get-assrep-header', {
        signal: this.getAssrepHeaderReq.signal,
      }).then((res) => {

        if (res) {
          this.setState({ getAssrepHeaderData: res.data })
        }
      })
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while getting data!'));

    }
  }


  // getAcademicBoards = () => {
  //   try {
  //     if (this.getAcademicBoardsReq) {
  //       this.getAcademicBoardsReq.abort();
  //     }
  //     this.getAcademicBoardsReq = new AbortController();
  //     GET('student-tracker/get-academic-boards', {
  //       signal: this.getAcademicBoardsReq.signal,
  //     }).then((res) => {
  //       if (res) {
  //         this.setState({ getAcademicBoardsData: res.data, selectedAcademicBoards: res.data.map((v, i) => { return { label: v.ab_name, value: v.ab_id } }) })
  //       }
  //     })
  //   } catch (err) {
  //     console.log('err', err)
  //     toast.error(t('Something went wrong while getting data!'));

  //   }
  // }

  getTerms = () => {
    try {
      if (this.getTermsReq) {
        this.getTermsReq.abort();
      }
      this.getTermsReq = new AbortController();
      GET('assessment-report/get-terms', {
        signal: this.getTermsReq.signal,
      }).then((res) => {

        if (res) {
          this.setState({
            terms: res.data.map(item => {
              return {
                ...item,
                value: item.term_id,
                label: item.term_name
              }
            })
          })
        }
      })
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while getting data!'));

    }
  }

  getStudentListAssessment = async () => {

    // if (!this.props.authData.userData) {
    //   toast.error(t('Seems like you are not an employee!'));
    //   return;
    // }

    const { authData } = this.props;
    const { auth_key } = authData.loginData;
    const { employee_id } = authData.userData;
    const { center_id } = authData.centerData;
    const { selectedAssrepHeader, selectedClass, selectedReportType, selectedTerm } = this.state;

    if (!selectedTerm && selectedTerm == null) {
      toast.error(t('Please select term'));
      return;
    }

    if (!selectedAssrepHeader && selectedAssrepHeader == null) {
      toast.error(t('Please select assessment report'));
      return;
    }

    if (!selectedClass && selectedClass == null) {
      toast.error(t('Please select class'));
      return;
    }

    if (!selectedReportType && selectedReportType == null) {
      toast.error(t('Please select report type'));
      return;
    }

    this.setState({ working: true, reportType: selectedReportType.value });

    try {
      const res = await GET('student-tracker/get-student-list-assessment', {
        params: {
          employee_id,
          class_id: selectedClass.value,
          assrepheader_id: selectedAssrepHeader.value,
          term_id: selectedTerm.value,
          assrep_report_type: selectedReportType.value
        },
      });

      if (res.status === 200) {
        this.setState({ studentListAssessment: res.data });
      }

      this.setState({ working: false });

    } catch (err) {
      console.log('err', err)

      this.setState({ working: false });
      toast.error(t('Something went wrong!'));
    }

  }

  render() {
    const { selectedAssrepHeader, selectedClass, reportData, isSaving, reRenderTime, selectedAcademicBoards, modalAssessSettings, assessSettingsData, assess_setting_background_image, progassData, learnareaData } = this.state

    let filteredClasses = []
    if (selectedAssrepHeader) {
      this.props.authData.classes.map((v, i) => {
        if (selectedAssrepHeader.agegroup_id == v.class.agegroup_id) {
          filteredClasses.push({ label: v.class.class_theme, value: v.class.class_id })
        }
      })
    }

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('Student Assessment Report')} backBtn={true} showCenterSelector={true} />
            <div className='grey-section' style={{ marginBottom: 20 }}>

              <Row className='justify-content-between'>
                <Col>
                  <Row>
                    <Col md={12} className='pe-0'>
                      <Row>
                        <Col md={3}>
                          <Select
                            placeholder={t('--TERM--')}
                            options={this.state.terms}
                            onChange={(event) => this.setState({ selectedTerm: event })
                            }
                            value={this.state.selectedTerm}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            formatOptionLabel={option => (
                              <div>
                                {option.label}
                                {option.term_active == 1 &&
                                  <span className='badge' style={{
                                    position: 'relative',
                                    top: -1,
                                    marginLeft: 5,
                                    backgroundColor: '#00d045'
                                  }}>ACTIVE</span>
                                }
                              </div>
                            )}
                          />
                        </Col>
                        <Col md={4} className='d-flex flex-row'>
                          <div style={{ flex: 1 }}>
                            <Select
                              placeholder={t('--ASSESSMENT REPORT--')}
                              options={this.state.getAssrepHeaderData.map((v, i) => { return { ...v, label: v.assrepheader_name, value: v.assrepheader_id, } })}
                              onChange={(event) => this.setState({ selectedAssrepHeader: event, selectedClass: null })}
                              value={selectedAssrepHeader}
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              formatOptionLabel={option => (
                                <div>
                                  <span className='badge' style={{
                                    position: 'relative',
                                    top: -1,
                                    backgroundColor: option.agegroup_color
                                  }}>{option.agegroup_code}</span>
                                  <span style={{ fontSize: 16, marginLeft: 10 }}>{option.label}</span>
                                </div>
                              )}
                            />
                          </div>
                          <div>
                            <Button
                              variant={'secondary'}
                              onClick={() => this.AddEditAssessmentReport.current.handleModal()}
                              style={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0, marginLeft: -3 }}
                            >
                              <FontAwesomeIcon icon={faPlus} style={{ fontSize: 16, color: brand_colors[this.props.defaultTheme.theme_id].color8, }} />
                            </Button>
                          </div>
                        </Col>
                        <Col md={2}>
                          <Select
                            placeholder={t('--CLASS--')}
                            options={filteredClasses}
                            onChange={(event) => this.setState({ selectedClass: event })
                            }
                            value={selectedClass}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            formatOptionLabel={option => (
                              <div>
                                <span style={{ fontSize: 16 }}>{option.label}</span>
                              </div>
                            )}
                          />
                        </Col>
                        <Col md={3}>
                          <Select
                            placeholder={t('--REPORT TYPE--')}
                            options={this.reportTypes}
                            onChange={(obj) => this.setState({ selectedReportType: obj })
                            }
                            value={this.state.selectedReportType}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            formatOptionLabel={option => (
                              <div>
                                <span style={{ fontSize: 16 }}>{option.label}</span>
                              </div>
                            )}
                          />
                        </Col>
                        {/* <Col md={12}>
                          <Select
                            isMulti
                            placeholder={t('--CURRICULUM--')}
                            options={this.state.getAcademicBoardsData.map((v, i) => { return { label: v.ab_name, value: v.ab_id } })}
                            onChange={(event) => this.setState({ selectedAcademicBoards: event })
                            }
                            value={selectedAcademicBoards}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            formatOptionLabel={option => (
                              <div>
                                <span style={{ fontSize: 16 }}>{option.label}</span>
                              </div>
                            )}
                          />
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col md={2} className='d-flex flex-row align-items-center'>
                  <div style={{ flex: 1 }} className='me-1'>
                    <Button style={{ width: '100%' }} disabled={this.state.working} variant={'primary'} onClick={() => this.getStudentListAssessment()}>
                      <div className='d-flex flex-row align-items-center'>
                        {this.state.working
                          ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' className='me-1' />
                          : <FontAwesomeIcon icon={faSearch} className='me-1' />
                        }
                        {t('Search')}
                      </div>
                    </Button>
                  </div>
                  <div style={{ flex: 1 }}>
                    <Button style={{ width: '100%' }} variant={'light'} onClick={() => modalAssessSettings.toggle()}>
                      <div className='d-flex flex-row align-items-center'>
                        <FontAwesomeIcon icon={faSlidersH} className='me-1' />
                        {t('Options')}
                      </div>
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
            <div className='grey-section'>
              {this.state.working ? (
                <Row className='flex-column text-center'>
                  <Col>
                    <Spinner
                      as='span'
                      animation='grow'
                      size='lg'
                      role='status'
                      aria-hidden='true'
                      className='mb-1'
                    />
                  </Col>
                  <Col>
                    {t('Fetching Reports...')}
                  </Col>
                </Row>
              ) : (
                <>
                  {this.state.studentListAssessment && this.state.studentListAssessment.length > 0 ? (
                    <>
                      {this.state.studentListAssessment.map((item, index) =>
                        <AssRepCard key={index} data={item} progassData={progassData} learnareaData={learnareaData} />)
                      }
                    </>
                  ) : (
                    <Row className='flex-column text-center'>
                      <Col>{t('No Data Found')}</Col>
                    </Row>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <AddEditAssessmentReport
          ref={this.AddEditAssessmentReport}
          authData={this.props.authData}
          selectedClass={this.props.selectedClass}
          callBack={this.getAssrepHeader}
          defaultTheme={this.props.defaultTheme}
          getAssrepHeaderData={this.state.getAssrepHeaderData}
        />

        <Offcanvas
          show={modalAssessSettings.show}
          onHide={() => modalAssessSettings.toggle()}
          placement={'end'}>
          <Offcanvas.Header>
            <div className='d-flex flex-row align-items-center justify-content-between' style={{ width: '100%' }}>
              <Offcanvas.Title>{t('Other Comments')}</Offcanvas.Title>
              <button
                type='button'
                className='btn-close'
                aria-label='Close'
                onClick={() => modalAssessSettings.toggle()}></button>
            </div>
          </Offcanvas.Header>
          {modalAssessSettings.show && assessSettingsData &&
            <Offcanvas.Body>
              {/* VISUAL REPRESENTATION */}
              <div className='d-flex flex-column justify-content-center align-items-center'>
                <div className='d-flex flex-row justify-content-between align-items-center' style={{ width: 300 }}>
                  <div className='d-flex flex-row justify-content-center align-items-center' style={{ width: 100, height: 100, backgroundColor: assessSettingsData.assess_setting_color1, borderRadius: 10, fontSize: 30, fontWeight: '600', color: assessSettingsData.assess_setting_color1_font }}>1</div>
                  <div className='d-flex flex-row justify-content-center align-items-center' style={{ width: 100, height: 100, backgroundColor: assessSettingsData.assess_setting_color2, borderRadius: 10, fontSize: 30, fontWeight: '600', color: assessSettingsData.assess_setting_color2_font }}>2</div>
                </div>
                <div className='d-flex flex-row justify-content-center align-items-center my-2'>
                  <div className='px-2 py-1' style={{ fontSize: 20, fontWeight: '600', borderRadius: 10, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg }}>{assessSettingsData.assess_comment_title}</div>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center' style={{ width: 300 }}>
                  <div className='d-flex flex-row justify-content-center align-items-center' style={{ width: 100, height: 100, backgroundColor: assessSettingsData.assess_setting_color3, borderRadius: 10, fontSize: 30, fontWeight: '600', color: assessSettingsData.assess_setting_color3_font }}>3</div>
                  <div className='d-flex flex-row justify-content-center align-items-center' style={{ width: 100, height: 100, backgroundColor: assessSettingsData.assess_setting_color4, borderRadius: 10, fontSize: 30, fontWeight: '600', color: assessSettingsData.assess_setting_color4_font }}>4</div>
                </div>
              </div>
              {/* FORM */}
              <div className='mt-3'>

                <Form.Group className='mb-3'>
                  <Form.Label>
                    {t('Comments Title')}
                  </Form.Label>
                  <Form.Control type='text' value={assessSettingsData.assess_comment_title} onChange={(event) => this.setState({ assessSettingsData: { ...assessSettingsData, assess_comment_title: event.target.value } })} />
                </Form.Group>

                {/* COLOR 1 BACKGROUND */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 1 Background')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color1_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color1, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color1_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color1: color.code, assess_setting_color1_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>
                {/* COLOR 1 TEXT */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 1 Text')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color1_font_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color1_font, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color1_font_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color1_font: color.code, assess_setting_color1_font_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>

                {/* COLOR 2 BACKGROUND */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 2 Background')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color2_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color2, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color2_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color2: color.code, assess_setting_color2_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>
                {/* COLOR 2 TEXT */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 2 Text')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color2_font_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color2_font, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color2_font_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color2_font: color.code, assess_setting_color2_font_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>

                {/* COLOR 3 BACKGROUND */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 3 Background')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color3_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color3, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color3_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color3: color.code, assess_setting_color3_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>
                {/* COLOR 3 TEXT */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 3 Text')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color3_font_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color3_font, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color3_font_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color3_font: color.code, assess_setting_color3_font_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>

                {/* COLOR 4 BACKGROUND */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 4 Background')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color4_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color4, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color4_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color4: color.code, assess_setting_color4_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>
                {/* COLOR 4 TEXT */}
                <div className='d-flex flex-row align-items-center justify-content-between p-1 mb-3' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].header_bg, borderRadius: 5 }}>
                  <div>{t('Comment 4 Text')}</div>
                  <div className='position-relative'>
                    <div onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color4_font_open: true } })} style={{ width: 70, borderRadius: 5, overflow: 'hidden', border: 'none', backgroundColor: assessSettingsData.assess_setting_color4_font, height: 20, cursor: 'pointer' }}>
                    </div>
                    {assessSettingsData.assess_setting_color4_font_open &&
                      <div className='color-palette' style={{ right: 0 }}>
                        {colorPalette.map((color, color_i) => (
                          <div key={color_i} onClick={() => this.setState({ assessSettingsData: { ...assessSettingsData, assess_setting_color4_font: color.code, assess_setting_color4_font_open: false } })} style={{ backgroundColor: color.code }} ></div>
                        ))}
                      </div>
                    }
                  </div>
                </div>

              </div>

              {/* IMAGE */}
              <div className='mt-3'>
                <div style={{ flexDirection: 'column' }} className='pic-prev d-flex justify-content-center'>
                  <div style={{ height: 175, padding: 10, overflow: 'hidden', borderStyle: 'dashed', borderColor: this.state.dragAreaColor.assess_setting_background_image, borderWidth: 2, borderRadius: 20, position: 'relative' }} className='d-flex justify-content-center align-items-center'
                    onDragEnter={(e) => this.handleDragFileArea(e, 'assess_setting_background_image')} onDragLeave={(e) => this.handleDragFileArea(e, 'assess_setting_background_image')} onDragOver={(e) => this.handleDragFileArea(e, 'assess_setting_background_image')} onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                        this.addAttachment({ target: { files: e.dataTransfer.files, multiple: false, name: 'assess_setting_background_image' } })
                      }
                    }}>
                    {assess_setting_background_image && (!assess_setting_background_image.data.type.includes('pdf')) && (
                      <img src={assess_setting_background_image.url} alt={t('Preview')} style={{ height: '100%' }} />
                    )}
                    {assess_setting_background_image == null &&
                      <button onClick={() => this.assess_setting_background_image_ref.current.click()} style={{ background: 'none', border: 0, flex: 1 }}>
                        {/* <FontAwesomeIcon icon={faPlus} style={{ fontSize: 30, color: color18 }} /> */}
                        <span style={{ fontSize: 20, fontWeight: 'bold', color: brand_colors[this.props.defaultTheme.theme_id].color18 }}>{t('Image')}</span>
                      </button>
                    }

                    {assess_setting_background_image && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        style={{ fontSize: 14, color: brand_colors[this.props.defaultTheme.theme_id].color11, position: 'absolute', bottom: 6, right: 6, cursor: 'pointer', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 100, padding: 3 }}
                        onClick={() => this.setState({ assess_setting_background_image: null })}
                      />
                    )}
                  </div>
                  <Form.Control className='d-none' ref={this.assess_setting_background_image_ref} type='file' onChange={this.addAttachment} name='assess_setting_background_image' />
                </div>
              </div>

              <div style={{ height: 300 }}></div>

              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8 }}>
                <div className="d-flex flex-row align-items-center justify-content-around py-3 px-2">
                  <div className='px-2' style={{ flex: 1 }}>
                    <Button variant='danger' style={{ width: '100%' }} onClick={() => modalAssessSettings.toggle()}>Cancel</Button>
                  </div>
                  <div className='px-2' style={{ flex: 1 }}>
                    <Button variant='warning' style={{ width: '100%' }} onClick={() => this.saveAssessSetting()}>Update</Button>
                  </div>
                </div>
              </div>
            </Offcanvas.Body>
          }
        </Offcanvas>

        <AIGenerationModal type='domain_area' />

      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  selectedClass: state.selectedClass.data,
  children: state.children.list,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(StudentAssessment);